import React from 'react';
import { Element } from '@craftjs/core';
import { PageText } from './PageText';

export const PageImageGalleryTitle = ({ children, ...props }) => {
  return (
    <div {...props}>
      <Element
			  id="image-gallery-title-text"
			  is={PageText}
			  canvas
			  custom={{ title: 'Image Gallery Title Text' }} fontSize={0} text={''}      >
        {children}
      </Element>
    </div>
  );
};

PageImageGalleryTitle.craft = {
  props: {
    'data-cy': 'call-to-action-title-container',
  },
  displayName: 'PageImageGalleryTitle',
};
